<iframe id="{{getIFrameID()}}" #OBJ_model_iframe class="tig-default" allowfullscreen [src]="OBJ_field_config._links.iframe.href|safe" style="border: none;overflow: hidden;height: 2500px;width: 100%"></iframe>
